/* @flow weak */
export default function getRedirectLocationAfterGroupCreation(group) {
  return `/classes/${group.getCodeOrError()}/messages/stream`;
}
